import { useState, useEffect } from "react";
import Layout from "./Layout";
import {
  list_sos_calls,
  update_sos_status,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  handleSuccessShow,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";

const Emergencies = () => {
  const [sosAlerts, setSosAlerts] = useState([]);
  const priorityFilter = "All";
  const [isLoading, setIsLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateForm, setUpdateForm] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);

  const filteredAlerts =
    priorityFilter === "All"
      ? sosAlerts
      : sosAlerts.filter((alert) => alert.priority === priorityFilter);

  const master_data_get = async () => {
    setIsLoading(true);
    let fd = new FormData();

    await server_post_data(list_sos_calls, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          setSosAlerts(Response.data.data);
          console.log(Response.data.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const handleViewDetails = (report) => {
    setSelectedReport(report);
    setShowModal(true);
  };
  const handleUpdateStatus = (report) => {
    setSelectedReport(report);
    setShowUpdateModal(true);
  };
  const handleAssignCase = (report) => {
    setSelectedReport(report);
    setShowAssignModal(true);
  };

  const handleupdateStatus = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("primary_id", selectedReport.primary_id);
    fd.append("flag", "0");
    fd.append("assign_to", "0");

    await server_post_data(update_sos_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setShowUpdateModal(false);
          setSelectedReport(null);
          setUpdateForm({});
          master_data_get();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleAssignToBooth = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let fd = new FormData();
    fd.append("primary_id", selectedReport.primary_id);
    fd.append("flag", "1");
    fd.append("assign_to", updateForm.status);

    await server_post_data(update_sos_status, fd)
      .then((Response) => {
        if (Response.data.error) {
          setIsLoading(false);
          handleError(Response.data.message);
        } else {
          handleSuccessShow(Response.data.message);
          setIsLoading(false);
          setShowUpdateModal(false);
          setSelectedReport(null);
          setUpdateForm({});
          master_data_get();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          <h2 className="page-title">Emergency Management</h2>

          {/* <div className="filter-bar">
          <label className="filter-label">Priority Filter:</label>
          <select
            className="select"
            value={priorityFilter}
            onChange={(e) => setPriorityFilter(e.target.value)}
          >
            <option value="All">All Priorities</option>
            <option value="High">High</option>
            <option value="Medium">Medium</option>
            <option value="Low">Low</option>
          </select>
        </div> */}

          <div className="content-grid">
            <div className="table-container">
              <table className="table">
                <thead>
                  <tr className="table-header">
                    <th className="th">Sr.No.</th>
                    <th className="th">Type</th>
                    <th className="th">Point</th>
                    <th className="th">Location</th>
                    <th className="th">Contact</th>
                    <th className="th">Status</th>
                    <th className="th">Assigned To</th>
                    <th className="th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAlerts.map((alert, index) => (
                    <tr key={alert.id} className="table-row">
                      <td className="td">{index + 1}</td>
                      <td className="td">{alert.type_of_emergency}</td>
                      <td className="td">{alert.point_address}</td>
                      <td className="td">
                        {/* {alert.lat}, {alert.long} */}
                        <a
                          href={`https://www.google.com/maps?q=${alert.lat},${alert.long}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline"
                        >
                          {alert.lat}, {alert.long}
                        </a>
                      </td>
                      <td className="td">
                        <div>{alert.name}</div>
                        <div className="phone-number">{alert.conatct}</div>
                      </td>{" "}
                      <td className="td">
                        <span
                          className={`type-badge ${
                            parseInt(alert.status) === 0 ? "missing" : "found"
                          }`}
                        >
                          {parseInt(alert.status) === 0 ? "Open" : "closed"}
                        </span>
                      </td>
                      <td className="td">
                        {alert.assign_to === ""
                          ? "Not Assigned"
                          : alert.assign_to}
                      </td>
                      <td className="td">
                        <div className="action-buttons">
                          <button
                            className="action-button"
                            onClick={() => handleViewDetails(alert)}
                          >
                            View
                          </button>
                          <button
                            className={`action-button success ${
                              alert.assign_to === "" ? "" : "Disaled"
                            }`}
                            onClick={() => handleAssignCase(alert)}
                          >
                            Assign To
                          </button>
                          <button
                            className={`action-button update-button ${
                              parseInt(alert.status) === 0 ? "" : "Disaled"
                            }`}
                            onClick={() => handleUpdateStatus(alert)}
                          >
                            Update Status
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* <div className="map-placeholder">
            <p className="map-text">Map Placeholder</p>
            <p className="map-subtext">
              Live location tracking will be displayed here
            </p>
          </div> */}
          </div>
        </div>

        {/* Modal for viewing details */}
        {showModal && selectedReport && (
          <div className="modal-overlay" onClick={() => setShowModal(false)}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Report Details</h3>
                <button
                  className="close-button"
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="modal-content">
                <img
                  src={selectedReport.photo || "/placeholder.svg"}
                  alt="Person"
                  className="modal-image"
                />
                <div className="modal-details">
                  <p>
                    <strong>Name:</strong> {selectedReport.name}
                  </p>
                  <p>
                    <strong>Emergency:</strong>{" "}
                    {selectedReport.type_of_emergency}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {parseInt(selectedReport.status) === 0 ? "Open" : "Closed"}
                  </p>
                  <p>
                    <strong>Assigned To:</strong>
                    {selectedReport.assign_to === ""
                      ? "Not Assigned"
                      : selectedReport.assign_to}
                  </p>
                  <p>
                    <strong>Description:</strong> {selectedReport.description}
                  </p>
                  <p>
                    <strong>Point Address:</strong>{" "}
                    {selectedReport.point_address}
                  </p>
                  <p>
                    <strong>Location:</strong>
                    <a
                      href={`https://www.google.com/maps?q=${selectedReport.lat},${selectedReport.long}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      {selectedReport.lat}, {selectedReport.long}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Update Modal */}
        {showUpdateModal && selectedReport && (
          <div
            className="modal-overlay"
            onClick={() => setShowUpdateModal(false)}
          >
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Change Status</h3>
                <button
                  className="close-button"
                  onClick={() => setShowUpdateModal(false)}
                >
                  ×
                </button>
              </div>
              <form>
                <div className="modal-content">
                  <div className="form-group">
                    <label className="label">Status:</label>
                    <select
                      className="select"
                      defaultValue={
                        updateForm?.status || selectedReport?.status
                      }
                      onChange={(e) =>
                        setUpdateForm({
                          ...updateForm,
                          status: e.target.value,
                        })
                      }
                    >
                      <option value="0">Open</option>
                      <option value="1">Closed</option>
                    </select>
                  </div>
                </div>
                <div className="modal-actions">
                  <button
                    type="submit"
                    className="modal-button"
                    onClick={handleupdateStatus}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="modal-button secondary"
                    onClick={() => setShowUpdateModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Asign Modal */}
        {showAssignModal && selectedReport && (
          <div
            className="modal-overlay"
            onClick={() => setShowAssignModal(false)}
          >
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>Change Status</h3>
                <button
                  className="close-button"
                  onClick={() => setShowAssignModal(false)}
                >
                  ×
                </button>
              </div>
              <form>
                <div className="modal-content">
                  <div className="form-group">
                    <label className="label">Status:</label>
                    <select
                      className="select"
                      defaultValue={
                        updateForm?.status || selectedReport?.status
                      }
                      onChange={(e) =>
                        setUpdateForm({
                          ...updateForm,
                          status: e.target.value,
                        })
                      }
                    >
                      <option value="Medical">Medical</option>
                      <option value="Police">Police</option>
                      <option value="Volunteer">Volunteer</option>
                    </select>
                  </div>
                </div>
                <div className="modal-actions">
                  <button
                    type="submit"
                    className="modal-button"
                    onClick={handleAssignToBooth}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="modal-button secondary"
                    onClick={() => setShowAssignModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </Layout>
    </>
  );
};

export default Emergencies;
